import React from 'react';
import { getSmoothStepPath, BaseEdge } from '@xyflow/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CustomSmoothStepEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const handleDelete = (event) => {
    event.stopPropagation();
    if (data?.onEdgeClick) {
      data.onEdgeClick(event, { id, action: 'delete' });
    }
  };

  // Mostra botão delete para todas as edges, incluindo as do loop
  const showDeleteButton = true;

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      {showDeleteButton && (
        <g 
          transform={`translate(${labelX}, ${labelY})`}
          style={{ 
            pointerEvents: 'all',
            zIndex: 1000 
          }}
        >
          {/* Círculo de fundo */}
          <circle
            r={12}
            fill="#ffffff"
            stroke={style.stroke || '#7b3fc0'}
            strokeWidth="2"
            style={{
              cursor: 'pointer',
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))',
              pointerEvents: 'all'
            }}
            onClick={handleDelete}
            onMouseDown={(e) => e.stopPropagation()}
            onMouseUp={(e) => e.stopPropagation()}
          />
          {/* Ícone X */}
          <foreignObject 
            x={-8} 
            y={-8} 
            width={16} 
            height={16}
            style={{ pointerEvents: 'all' }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                color: style.stroke || '#7b3fc0',
                fontSize: '10px',
                cursor: 'pointer',
                userSelect: 'none',
                pointerEvents: 'all',
                zIndex: 1001
              }}
              onClick={handleDelete}
              onMouseDown={(e) => e.stopPropagation()}
              onMouseUp={(e) => e.stopPropagation()}
              onDragStart={(e) => e.preventDefault()}
            >
              <FontAwesomeIcon icon="fa-solid fa-times" />
            </div>
          </foreignObject>
        </g>
      )}
    </>
  );
};

export default CustomSmoothStepEdge;
